import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  container: {
    maxWidth: "x1vpbbxe",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingTop: "x128v7jw",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBottom: "x1q8uoa4",
    $$css: true
  },
  title: {
    marginTop: "xdj266r",
    marginBottom: "xhbfen4",
    fontSize: "x1q74xe4",
    lineHeight: "x1u7k74",
    $$css: true
  },
  meta: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    alignItems: "x6s0dn4",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    marginTop: "xdj266r",
    marginBottom: "x1t84w78",
    fontSize: "x1dcheo9",
    $$css: true
  },
  altLink: {
    color: "x1gonuu0",
    fontWeight: "xr323w7",
    $$css: true
  },
  contents: {
    backgroundColor: "x80m72e",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    marginBottom: "x1t84w78",
    $$css: true
  },
  contentsHeading: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "x1ncqgef",
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    letterSpacing: "x9pfba7",
    textTransform: "xtvhhri",
    color: "xarw3lm",
    $$css: true
  },
  contentsList: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    paddingLeft: "x1uae1lo",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    fontSize: "x6u19be",
    $$css: true
  },
  section: {
    scrollMarginTop: "xh0p2b3",
    marginBottom: "x1t84w78",
    $$css: true
  },
  heading: {
    marginTop: "xdj266r",
    marginBottom: "x1gr9t9r",
    fontSize: "x1603h9y",
    lineHeight: "x1u7k74",
    $$css: true
  },
  subheading: {
    marginTop: "x1c4vshn",
    marginBottom: "xhbfen4",
    fontSize: "x1lkfr7t",
    $$css: true
  },
  paragraph: {
    marginTop: "xdj266r",
    marginBottom: "x1gr9t9r",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  list: {
    marginTop: "xdj266r",
    marginBottom: "x1gr9t9r",
    paddingLeft: "x1uae1lo",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    lineHeight: "x1evy7pa",
    $$css: true
  },
  listItem: {
    marginBottom: "x18jvhmb",
    $$css: true
  },
  tableScroll: {
    overflowX: "xw2csxc",
    marginBottom: "x1gr9t9r",
    $$css: true
  },
  table: {
    borderCollapse: "x1mwwwfo",
    width: "xh8yej3",
    minWidth: "xzcui5c",
    fontSize: "xkpwil5",
    $$css: true
  },
  th: {
    textAlign: "xdpxx8g",
    verticalAlign: "x16dsc37",
    padding: "x7gbtqy",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderBottomWidth: "xlxy82",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "xbuxeer",
    fontWeight: "xlr2uoh",
    $$css: true
  },
  td: {
    textAlign: "xdpxx8g",
    verticalAlign: "x16dsc37",
    padding: "x7gbtqy",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "xbuxeer",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  callout: {
    backgroundColor: "x15xno7f",
    color: "xw6893c",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    marginBottom: "x1gr9t9r",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  link: {
    color: "x1gonuu0",
    $$css: true
  },
  todo: {
    backgroundColor: "x13g1blz",
    color: "x12si0go",
    paddingInline: "xllzysa",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    borderRadius: "xjiwlmt",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontFamily: "x1n2ylgu",
    fontSize: "x1s8wshw",
    $$css: true
  }
};